// extracted by css-extract-rspack-plugin
export default {"taxonomiesEditor":"taxonomiesEditor-Z50WPH","roleTaxonomyIdSelect":"roleTaxonomyIdSelect-XxLNZy"};